// Anonymous voter id — lets logged-out visitors vote (like VDM / DansTonChat)
// without an account. We persist a random UUID in localStorage and send it to
// the backend, which combines it with the request IP + a secret salt to derive
// a stable, non-reversible key for deduplicating anonymous votes.
//
// The UUID alone identifies nobody and carries no personal data; it only needs
// to be stable per browser. It is created lazily on first use.

const ANON_KEY = 'lb_anon_id'

function makeUuid() {
  // Prefer the native crypto UUID; fall back for very old browsers.
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// Return the persisted anonymous id, creating it on first call.
export function getAnonId() {
  try {
    let id = localStorage.getItem(ANON_KEY)
    if (!id) {
      id = makeUuid()
      localStorage.setItem(ANON_KEY, id)
    }
    return id
  } catch {
    // localStorage unavailable (private mode quirks) → ephemeral id.
    return makeUuid()
  }
}
